import { Divider, Space } from 'antd';
import ContainerWrapper from 'Common/Components/ContainerWrapper';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ReadersList from '../components/ReadersList';
import OrderReader from '../components/OrderReader';
import AccountAddressChecker from '../components/AccountAddressChecker';

const Title = styled.h3`
  margin: 0;
  padding: 20px 24px;
`;

const ReadersScreen: React.FC = () => (
  <ContainerWrapper css="margin: 24px">
    <Title>
      <FormattedMessage defaultMessage="My Readers" />
    </Title>
    <Divider css="margin: 0" />
    <Space
      size="large"
      direction="vertical"
      css={`
        width: 100%;
        padding: 22px 46px;
      `}
    >
      <AccountAddressChecker />
      <ReadersList />
      <OrderReader />
    </Space>
  </ContainerWrapper>
);

export default ReadersScreen;
